export var AiFeedbackReaction;
(function (AiFeedbackReaction) {
    AiFeedbackReaction[AiFeedbackReaction["Negative"] = -1] = "Negative";
    AiFeedbackReaction[AiFeedbackReaction["Positive"] = 1] = "Positive";
})(AiFeedbackReaction || (AiFeedbackReaction = {}));
export var AiFeedbackType;
(function (AiFeedbackType) {
    AiFeedbackType[AiFeedbackType["QnAFeedback"] = 0] = "QnAFeedback";
    AiFeedbackType[AiFeedbackType["SummaryFeedback"] = 1] = "SummaryFeedback";
})(AiFeedbackType || (AiFeedbackType = {}));
export var QueryScopeKey;
(function (QueryScopeKey) {
    QueryScopeKey["StudyIds"] = "studyIds";
    QueryScopeKey["ActivityScope"] = "activityScope";
    QueryScopeKey["TaskScope"] = "taskScope";
    QueryScopeKey["TopicsScope"] = "topicScope";
    QueryScopeKey["CategoriesScope"] = "categoryScope";
    QueryScopeKey["SegmentIds"] = "segmentIds";
    QueryScopeKey["UserIds"] = "userIds";
})(QueryScopeKey || (QueryScopeKey = {}));
export var QueryFilterKey;
(function (QueryFilterKey) {
    QueryFilterKey["Studies"] = "studies";
    QueryFilterKey["Activities"] = "activities";
    QueryFilterKey["Tasks"] = "tasks";
    QueryFilterKey["Discussions"] = "discussions";
    QueryFilterKey["Categories"] = "categories";
    QueryFilterKey["Segments"] = "segments";
    QueryFilterKey["Participants"] = "participants";
})(QueryFilterKey || (QueryFilterKey = {}));
export var AnalysisMode;
(function (AnalysisMode) {
    AnalysisMode["STANDARD"] = "standard";
    AnalysisMode["PREDICTIVE"] = "predictive";
})(AnalysisMode || (AnalysisMode = {}));
export var QueryEmbeddingLevel;
(function (QueryEmbeddingLevel) {
    QueryEmbeddingLevel["ALL"] = "ALL";
    QueryEmbeddingLevel["RAW"] = "RAW";
    QueryEmbeddingLevel["LARGE"] = "LARGE";
    QueryEmbeddingLevel["MEDIUM"] = "MEDIUM";
    QueryEmbeddingLevel["SMALL"] = "SMALL";
    QueryEmbeddingLevel["SENTENCE"] = "SENTENCE";
    QueryEmbeddingLevel["SENTENCE_PARENT"] = "SENTENCE_PARENT";
})(QueryEmbeddingLevel || (QueryEmbeddingLevel = {}));
export var QnAAnswerErrorReasonCode;
(function (QnAAnswerErrorReasonCode) {
    QnAAnswerErrorReasonCode["EmptySegment"] = "empty_segment";
    QnAAnswerErrorReasonCode["InsufficientContext"] = "insufficient_context";
    QnAAnswerErrorReasonCode["UnsupportedAnswer"] = "unsupported_answer";
    QnAAnswerErrorReasonCode["InternalServerError"] = "internal_server_error";
    QnAAnswerErrorReasonCode["MentionsSubsetOfFilters"] = "mentions_must_be_subset_of_filters";
    QnAAnswerErrorReasonCode["MentionsNotSupported"] = "mentions_not_supported";
    QnAAnswerErrorReasonCode["CrossStudyNoRelevantStudyAnswers"] = "cross_study_no_relevant_study_answers";
})(QnAAnswerErrorReasonCode || (QnAAnswerErrorReasonCode = {}));
export var QnAAnswerContentType;
(function (QnAAnswerContentType) {
    QnAAnswerContentType["Markdown"] = "MARKDOWN";
    QnAAnswerContentType["Html"] = "HTML";
    QnAAnswerContentType["Text"] = "TEXT";
})(QnAAnswerContentType || (QnAAnswerContentType = {}));
export var QnAAnswerSourceError;
(function (QnAAnswerSourceError) {
    QnAAnswerSourceError["Edited"] = "EDITED";
    QnAAnswerSourceError["Deleted"] = "DELETED";
    QnAAnswerSourceError["Rejected"] = "REJECTED"; // The original response has been rejected and is awaiting an update
})(QnAAnswerSourceError || (QnAAnswerSourceError = {}));
export var AiFlag;
(function (AiFlag) {
    AiFlag["SITE_LEVEL"] = "SITE_LEVEL";
    AiFlag["STUDY_LEVEL"] = "STUDY_LEVEL";
    AiFlag["DISABLED"] = "DISABLED";
})(AiFlag || (AiFlag = {}));
export var StudyState;
(function (StudyState) {
    StudyState["Open"] = "open";
    StudyState["Closed"] = "closed";
    StudyState["Draft"] = "draft";
    StudyState["Archived"] = "archived";
})(StudyState || (StudyState = {}));
export var ActivityState;
(function (ActivityState) {
    ActivityState["Active"] = "active";
    ActivityState["Expired"] = "expired";
    ActivityState["Archived"] = "archived";
})(ActivityState || (ActivityState = {}));
export var IngestionFeature;
(function (IngestionFeature) {
    IngestionFeature["Questions"] = "questions";
    IngestionFeature["Translations"] = "translations";
})(IngestionFeature || (IngestionFeature = {}));
export var FeatureIngestionState;
(function (FeatureIngestionState) {
    FeatureIngestionState["Full"] = "full";
    FeatureIngestionState["Partial"] = "partial";
    FeatureIngestionState["None"] = "none";
    FeatureIngestionState["Disabled"] = "disabled";
    FeatureIngestionState["Unsupported"] = "unsupported";
})(FeatureIngestionState || (FeatureIngestionState = {}));
export var AIIngestJobState;
(function (AIIngestJobState) {
    AIIngestJobState["Pending"] = "pending";
    AIIngestJobState["InProgress"] = "in_progress";
    AIIngestJobState["Completed"] = "completed";
    AIIngestJobState["Failed"] = "failed";
    AIIngestJobState["CompletedWithErrors"] = "completed_with_errors";
    AIIngestJobState["TimedOut"] = "timed_out";
    AIIngestJobState["Cancelled"] = "cancelled";
})(AIIngestJobState || (AIIngestJobState = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["Live"] = "live";
    ActivityType["Async"] = "async";
})(ActivityType || (ActivityType = {}));
export var AIIngestionCostEstimation;
(function (AIIngestionCostEstimation) {
    AIIngestionCostEstimation["Low"] = "low";
    AIIngestionCostEstimation["Medium"] = "medium";
    AIIngestionCostEstimation["High"] = "high";
})(AIIngestionCostEstimation || (AIIngestionCostEstimation = {}));
export var AIIngestUrgency;
(function (AIIngestUrgency) {
    AIIngestUrgency["Low"] = "low";
    AIIngestUrgency["Medium"] = "medium";
    AIIngestUrgency["High"] = "high";
})(AIIngestUrgency || (AIIngestUrgency = {}));
